import { render } from "./FGCObsView.vue?vue&type=template&id=09885cfe&scoped=true&ts=true"
import script from "./FGCObsView.vue?vue&type=script&lang=ts"
export * from "./FGCObsView.vue?vue&type=script&lang=ts"

import "./FGCObsView.vue?vue&type=style&index=0&id=09885cfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09885cfe"]])

export default __exports__